// this is an autogenerated file from App/Account/Content/Tasks/New/MigrationModal/data.graphql
import { gql } from 'Data/Api'

export default gql`
query app__App_Account_Content_Tasks_New_MigrationModal{
  tasks_boards {
    id
  }
  vaxiom_task_baskets {
    id
  }
}

`